import { Link } from "react-router-dom";
import type { ToolCatalogItem } from "@/features/tools/proToolTypes";

type ProToolCardProps = {
  tool: ToolCatalogItem;
  href?: string;
  benefit?: string;
  onOpen?: (tool: ToolCatalogItem) => void;
};

export function ProToolCard({ tool, href, benefit, onOpen }: ProToolCardProps) {
  const isLocked = tool.status === "locked";
  const isAvailable = tool.status === "available";
  const isActionable =
    (tool.toolType === "launch_readiness_checker" ||
      tool.toolType === "monetisation_model_suggester" ||
      tool.toolType === "sales_page_headline_generator") &&
    isAvailable;
  const buttonLabel = href
    ? "Open tool"
    : tool.toolType === "monetisation_model_suggester"
      ? "Open suggester"
      : tool.toolType === "sales_page_headline_generator"
        ? "Open generator"
        : "Open checker";

  return (
    <article className="flex min-h-full w-full min-w-0 max-w-full flex-col rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition hover:border-indigo-200 hover:shadow-md">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-indigo-700">
          {isLocked || isActionable ? "Included with Pro" : "Pro tool"}
        </p>
        <h3 className="mt-2 break-words text-lg font-semibold text-slate-950">
          {tool.name}
        </h3>
        <p className="mt-3 break-words text-sm leading-6 text-slate-600">
          {benefit ?? tool.description}
        </p>
      </div>

      {isLocked ? (
        <Link
          to="/pricing"
          className="mt-5 inline-flex w-full justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 sm:w-fit"
        >
          Upgrade to Pro
        </Link>
      ) : isActionable && href ? (
        <Link
          to={href}
          className="mt-5 inline-flex w-full justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 sm:w-fit"
        >
          {buttonLabel}
        </Link>
      ) : isActionable ? (
        <button
          type="button"
          onClick={() => onOpen?.(tool)}
          className="mt-5 w-full rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 sm:w-fit"
        >
          {buttonLabel}
        </button>
      ) : (
        <div className="mt-5 rounded-md border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-700">
          Coming next
        </div>
      )}
    </article>
  );
}
